import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Report from './pages/Report';
import RestaurantGoers from './pages/RestaurantGoers';
import RestaurantWorkers from './pages/RestaurantWorkers';
import RestaurantOwners from './pages/RestaurantOwners';
import NotFound from './pages/NotFound';
import './App.css';

// Component to handle document title updates
const DocumentTitle = () => {
  const { translate } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    const getTitle = () => {
      switch (location.pathname) {
        case '/':
          return translate('PAGE_TITLE_HOME');
        case '/report-an-incident':
          return translate('PAGE_TITLE_REPORT');
        case '/restaurant-goers':
          return translate('PAGE_TITLE_RESTAURANT_GOERS');
        case '/restaurant-workers':
          return translate('PAGE_TITLE_RESTAURANT_WORKERS');
        case '/restaurant-owners':
          return translate('PAGE_TITLE_RESTAURANT_OWNERS');
        default:
          return translate('SITE_NAME');
      }
    };

    document.title = getTitle();
    window.scrollTo(0, 0);
  }, [location.pathname, translate]);

  return null;
};

// Main App content component
const AppContent = () => {
  return (
    <div className="App">
      <DocumentTitle />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/restaurant-goers" element={<RestaurantGoers />} />
        <Route path="/restaurant-workers" element={<RestaurantWorkers />} />
        <Route path="/restaurant-owners" element={<RestaurantOwners />} />
        <Route path="/report-an-incident" element={<Report />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

// Main App component with providers
const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
};

export default App;